export default function Footer() {
  return (
    <footer className="bg-[#2C4A3E] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Legalization */}
          <div>
            <h4 className="text-lg font-bold mb-4">양성화 신청</h4>
            <ul className="space-y-2">
              <li>
                <a href="#diagnosis" className="text-sm text-gray-300 hover:text-white transition-colors">
                  긴급 진단
                </a>
              </li>
              <li>
                <a href="#cases" className="text-sm text-gray-300 hover:text-white transition-colors">
                  사례 연구
                </a>
              </li>
              <li>
                <a href="#process" className="text-sm text-gray-300 hover:text-white transition-colors">
                  신청 절차
                </a>
              </li>
            </ul>
          </div>

          {/* Column 2 - Old Housing */}
          <div>
            <h4 className="text-lg font-bold mb-4">노후주택 지원</h4>
            <ul className="space-y-2">
              <li>
                <a href="#old-housing" className="text-sm text-gray-300 hover:text-white transition-colors">
                  지원 자격
                </a>
              </li>
              <li>
                <a href="#old-housing" className="text-sm text-gray-300 hover:text-white transition-colors">
                  보조금 안내
                </a>
              </li>
              <li>
                <a href="#old-housing" className="text-sm text-gray-300 hover:text-white transition-colors">
                  신청 방법
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Support */}
          <div>
            <h4 className="text-lg font-bold mb-4">고객 지원</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                  자주 묻는 질문
                </a>
              </li>
              <li>
                <a href="#consultation" className="text-sm text-gray-300 hover:text-white transition-colors">
                  전문가 상담
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                  서류 다운로드
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">정보</h4>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                  정책 뉴스
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                  법령 정보
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                  담당 기관
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Copyright */}
            <p className="text-sm text-gray-300">
              © 2026 주택지원센터. All rights reserved.
            </p>

            {/* Social Media */}
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <i className="ri-kakao-talk-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <i className="ri-blogger-line text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>

            {/* Privacy Policy & Readdy Link */}
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-gray-300 hover:text-white transition-colors">
                개인정보처리방침
              </a>
              <span className="text-gray-500">|</span>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
